import { scienceStatus, scientificStage, scientificStages, type ScienceTask } from '@/lib/scientific'

/** Show the pipeline stage separately from the expert's decision. */
export function TaskStatusTags({ task, earlyReview = false }: { task: ScienceTask; earlyReview?: boolean }) {
  const stage = scientificStage(task)
  const review = task.scientific.review?.verdict
  const label = earlyReview ? 'Expert review' : stage === 'published' ? 'Published' : stage === 'rollouts' || task.scientific.status === 'qc_passed' ? scienceStatus(task.scientific.status)
    : scientificStages.find(([key]) => key === stage)?.[1]
  return <span className="science-status-tags">
    <span className={`chip ${task.scientific.status === 'qc_passed' || stage === 'published' ? 'ok' : stage === 'quality' ? 'review-kind quality' : 'neutral'}`}>{label}</span>
    {stage === 'review' && review && <span className={`chip ${review === 'ready' ? 'ok' : 'warn'}`}>{review === 'ready' ? 'Ready' : 'Needs changes'}</span>}
  </span>
}
